export default "__VITE_ASSET__12915b87__"